import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import ScrollMagicFn from '@/utils/ScrollMagic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

let textSceneG: any = null,
    controller = null;
export default function G() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [isH5, setIsH5] = useState(false);
    const SITE_JP = 'jp';

    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (textSceneG) {
                    AniContainer.removeScene(textSceneG);
                    textSceneG = null;
                }

                controller = new ScrollMagic.Controller();
                const sceneScale = new ScrollMagic.Scene({
                    triggerElement: '.dpu-detail-G',
                    triggerHook: 1,
                    offset: window?.innerHeight * 2.5,
                    duration: window?.innerHeight,
                });

                const terminal = window?.innerWidth >= 1440 ? 1 : window?.innerWidth > 1024 ? 2 : window?.innerWidth >= 768 ? 3 : 4;
                if (window?.innerWidth > 1024) {
                    const tweenScale = TweenMax.fromTo(
                        '.dpu-detail-G .video-box',
                        0.5,
                        {
                            width: '100%',
                            height: '100%',
                        },
                        {
                            width:
                                terminal === 1
                                    ? '1200px'
                                    : terminal === 2
                                    ? 'calc(100vw - 444px)'
                                    : terminal === 3
                                    ? 'calc(100vw - 256px)'
                                    : 'calc(100vw - 48px)',
                            height: terminal === 1 ? 600 : terminal === 2 ? 499 : 270,
                        },
                    );
                    sceneScale.setTween(tweenScale);
                    controller.addScene(sceneScale);
                }

                textSceneG =
                    locale === SITE_JP
                        ? AniContainer.create({
                              asyncFromTo: [
                                  ['.dpu-detail-G .box0 .title', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.2],
                                  ['.dpu-detail-G .box0 .title', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 1.5],
                                  ['.dpu-detail-G .video-box .mask', { opacity: 0 }, { opacity: 1 }, 0.25],
                                  ['.dpu-detail-G .box2-layer-h5', { opacity: 0 }, { opacity: 0.2 }, 0.1],
                                  ['.dpu-detail-G .box2 .subtitle', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2 .title', { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2 .desc', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2', { opacity: 1 }, { opacity: 1 }, 0.5],
                              ],
                              asyncTimeLine: [0.2, 0.5, 3, 0.1, 3, 3.25, 3.5, 3.75],
                              triggerElement: '.dpu-detail-G',
                              triggerHook: 0,
                              offset: 0,
                              duration: '300%',
                          })
                        : AniContainer.create({
                              asyncFromTo: [
                                  ['.dpu-detail-G .box0 .title', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.2],
                                  ['.dpu-detail-G .box0 .title', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 0.5],
                                  ['.dpu-detail-G .video-box .video1', { opacity: 1 }, { opacity: 0 }, 0.25],
                                  ['.dpu-detail-G .video-box .video2', { opacity: 0 }, { opacity: 1 }, 0.25],
                                  ['.dpu-detail-G .box1 .title', { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box1 .title', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 0.1],
                                  ['.dpu-detail-G .video-box .mask', { opacity: 0 }, { opacity: 1 }, 0.25],
                                  ['.dpu-detail-G .box2-layer-h5', { opacity: 0 }, { opacity: 0.2 }, 0.1],
                                  ['.dpu-detail-G .box2 .subtitle', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2 .title', { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2 .desc', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.5],
                                  ['.dpu-detail-G .box2', { opacity: 1 }, { opacity: 1 }, 0.5],
                              ],
                              asyncTimeLine: [0.2, 0.5, 1, 1, 1.25, 2, 3, 0.1, 3, 3.25, 3.5, 3.75],
                              triggerElement: '.dpu-detail-G',
                              triggerHook: 0,
                              offset: 0,
                              duration: '300%',
                          });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (textSceneG) {
                    AniContainer.removeScene(textSceneG);
                    textSceneG = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [isH5]);

    return (
        <section className={`dpu-detail-G dpu-detail-section ${css['dpu-detail-G']}`}>
            <div className="sticky-box">
                <div className={`video-box ${isH5 ? 'g-h5' : 'g-pc'}`}>
                    {!isH5 && (
                        <EFVideo
                            // ref={videoRef1PC}
                            sources={['/responsive/video/delta-pro-ultra/launch/6.mp4']}
                            className="video1 video pc"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secF_title')}
                        />
                    )}
                    {!isH5 && locale !== SITE_JP && (
                        <EFVideo
                            // ref={videoRef2PC}
                            sources={['/responsive/video/delta-pro-ultra/launch/7.mp4']}
                            className="video2 video pc"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secG_sec1_title')}
                        />
                    )}
                    {isH5 && (
                        <EFVideo
                            // ref={videoRef1H5}
                            sources={['/responsive/video/delta-pro-ultra/launch/6_h5.mp4']}
                            className="video1 video h5"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secF_title')}
                        />
                    )}
                    {isH5 && locale !== SITE_JP && (
                        <EFVideo
                            // ref={videoRef2H5}
                            sources={['/responsive/video/delta-pro-ultra/launch/7_h5.mp4']}
                            className="video2 video h5"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secG_sec1_title')}
                        />
                    )}
                    <div className="mask"></div>
                    {/* {locale === SITE_JP && <p className="tip">{t('secG_tip')}</p>} */}
                </div>
                <div className="box0 box">
                    <div className="box-in">
                        <h2 className="title">{t('secF_title')}</h2>
                    </div>
                </div>
                {locale !== SITE_JP && (
                    <div className="box1 box">
                        <div className="box-in">
                            <h2 className="title">{t('secG_sec1_title')}</h2>
                        </div>
                    </div>
                )}
                <div className="box2-layer-h5"></div>
                <div className="box2 box">
                    <div className="box-in">
                        <h4 className="subtitle">{t('secG_sec2_subtitle')}</h4>
                        <h2 className="title">{t('secG_sec2_title')}</h2>
                        <p className="desc">
                            {t.rich('secG_sec2_desc', {
                                sup: (text: any) => <sup className="sup">{text}</sup>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
